module.exports = __webpack_public_path__ + "img/coin.0e56c573.gif";